import React from 'react'
import Link from 'gatsby-link'
import { Route } from 'react-router'

import Logo from '../logo'
import MenuButton from './menu-button'
import Menu from '../menu/menu'

import ArticleFilterSort from './articleFilterSort'
import PortfolioFilter from './portfolioFilter'

import GlobalPropsProvider from '../utils/stateProvider'

import buildLink from '../../helpers/linkBuilder'

import Styles from '../../styles/components/header.module.scss'
import globalState from '../../helpers/globalState'
const {
  header,
  container,
  headerFilters,
  headerLogo,
  headerMenu,
  headerMenuPos,
  fixed,
  fixedHiding,
  absolute,
  absoluteHiding,
  headerLogoFaded,
} = Styles

const AnimationDuration = 300

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.onResize = this.onResize.bind(this)

    this.state = {
      logoWidth: 0,
      logoHeight: 0,
      logoLeft: 0,
      logoOffset: 0,
      logoHiding: null,

      menuButtonTop: 20,
      menuButtonWidth: 0,
      menuButtonHeight: 0,
      menuButtonLeft: 0,
      menuButtonHiding: null,

      headerBottom: 0,
      headerHeight: 0,
    }

    this.isWatchingResize = false
    this.watchingResizeTimeout = null
  }

  onResize() {
    const logoRect = this.headerLogo.getBoundingClientRect()
    const menuButtonRect = this.headerMenuButton.getBoundingClientRect()

    this.setState(state => ({
      ...state,
      logoWidth: logoRect.width,
      logoHeight: menuButtonRect.height,
      logoLeft: logoRect.left,
      logoOffset: logoRect.top - menuButtonRect.top,
      menuButtonWidth: menuButtonRect.width,
      menuButtonHeight: menuButtonRect.height,
      menuButtonLeft: menuButtonRect.left,
      headerBottom: menuButtonRect.bottom,
      headerHeight: this.headerContainer.offsetHeight,
    }))
    globalState.setState({ menuRightFromLeft: menuButtonRect.right })
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.isWatchingResize &&
      (nextProps.fixedMenu || nextProps.fixedLogo)
    ) {
      window.addEventListener('resize', this.onResize)
      this.onResize()
      this.isWatchingResize = true

      if (this.watchingResizeTimeout) {
        clearTimeout(this.watchingResizeTimeout)
        this.watchingResizeTimeout = null
      }
    }

    if (this.props.fixedMenu !== nextProps.fixedMenu && !nextProps.fixedMenu) {
      this.setState(state => ({
        ...state,
        menuButtonHiding: this.state.headerBottom < 0 ? 'fixed' : 'absolute',
      }))

      setTimeout(() => {
        this.setState(state => ({ ...state, menuButtonHiding: false }))
      }, AnimationDuration)
    }

    if (this.props.fixedLogo !== nextProps.fixedLogo && !nextProps.fixedLogo) {
      this.setState(state => ({
        ...state,
        logoHiding: this.state.headerBottom < 0 ? 'fixed' : 'absolute',
      }))

      setTimeout(() => {
        this.setState(state => ({ ...state, logoHiding: false }))
      }, AnimationDuration)
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (
      this.isWatchingResize &&
      (!nextProps.fixedMenu &&
        !nextProps.fixedLogo &&
        !(nextState.menuButtonHiding === 'fixed') &&
        !(nextState.logoHiding === 'fixed'))
    ) {
      this.watchingResizeTimeout = setTimeout(() => {
        window.removeEventListener('resize', this.onResize)
        this.isWatchingResize = false
      }, AnimationDuration) // a little more after css transition end
    }
  }

  componentDidMount() {
    if (document.readyState === 'complete') {
      this.onResize()
    } else {
      window.addEventListener('load', this.onResize)
    }
  }

  render() {
    const {
      whiteLogo,
      menuOpen,
      menuHover,
      fixedMenu,
      fixedLogo,
      headerWidget,
      language,
      inMenuScrolled,
      windowWide,
    } = this.props
    const { logoHiding, menuButtonHiding } = this.state

    const menuButtonStyle =
      fixedMenu || menuButtonHiding === 'fixed'
        ? {
            height: this.state.menuButtonHeight,
            left: this.state.menuButtonLeft,
            width: this.state.menuButtonWidth,
            transform: `translateY(${
              menuButtonHiding === 'fixed'
                ? -this.state.headerHeight
                : Math.max(0, this.state.headerBottom) - this.state.headerHeight
            }px)`,
          }
        : {
            transform: `translateY(${
              menuButtonHiding === 'absolute'
                ? -this.state.headerBottom + this.state.headerHeight
                : 0
            }px)`,
          }

    const logoStyle =
      fixedLogo || logoHiding === 'fixed'
        ? {
            height: this.state.logoHeight,
            left: this.state.logoLeft,
            top: this.state.logoOffset + 20,
            width: this.state.logoWidth,
            transform: `translateY(${
              logoHiding === 'fixed'
                ? -this.state.headerHeight
                : Math.max(0, this.state.headerBottom) - this.state.headerHeight
            }px)`,
          }
        : {
            transform: `translateY(${
              logoHiding === 'absolute'
                ? -this.state.headerBottom + +this.state.headerHeight
                : 0
            }px)`,
          }

    return (
      <div className={header}>
        <Menu open={menuOpen} hover={menuHover} />
        <div className={container} ref={ref => (this.headerContainer = ref)}>
          <div
            className={
              menuOpen && inMenuScrolled ? headerLogoFaded : headerLogo
            }
            ref={ref => (this.headerLogo = ref)}
          >
            <div
              className={
                logoHiding === 'fixed'
                  ? fixedHiding
                  : fixedLogo
                    ? fixed
                    : logoHiding === 'absolute' ? absoluteHiding : absolute
              }
              style={logoStyle}
            >
              <Link
                to={buildLink({
                  lang: language,
                  slug: '',
                  type: 'page',
                })}
              >
                <Logo expanded={menuOpen} light={menuOpen} />
              </Link>
            </div>
          </div>
          {windowWide && (
            <div className={headerFilters}>
              {headerWidget === 'articleFilterSort' && <ArticleFilterSort />}
              {headerWidget === 'portfolioFilter' && <PortfolioFilter />}
            </div>
          )}

          <div
            className={headerMenu}
            ref={ref => (this.headerMenuButton = ref)}
          >
            <div
              className={
                menuButtonHiding === 'fixed'
                  ? fixedHiding
                  : fixedMenu
                    ? fixed
                    : menuButtonHiding === 'absolute'
                      ? absoluteHiding
                      : absolute
              }
              style={menuButtonStyle}
            >
              <MenuButton />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GlobalPropsProvider(Header, state => ({
  menuOpen: state.menuOpen,
  menuHover: state.menuHover,
  fixedMenu: state.fixedMenu,
  inMenuScrolled: state.inMenuScrolled,
  fixedLogo: state.fixedLogo,
  whiteLogo: state.whiteLogo,
  headerWidget: state.headerWidget,
  language: state.language,
  windowWide: state.windowWidth > 1200,
}))



// WEBPACK FOOTER //
// ./src/components/header/header.js